import type { AccentHue } from "@repo/fika-design-system/color"
import { For } from "solid-js"
import type { HighlightPiece } from "../../lib/search-highlight"
import { markRecipe } from "./mark.css"

type Props = {
  hue: AccentHue
  pieces: HighlightPiece[]
}
export function Mark(props: Props) {
  const getContent = (child: HighlightPiece) => {
    if (typeof child === "string") {
      return child
    }

    if (typeof child === "object" && child !== null) {
      return <mark class={markRecipe({ hue: props.hue })}>{child.mark}</mark>
    }

    return ""
  }

  return (
    <For each={props.pieces}>
      {piece => {
        return getContent(piece)
      }}
    </For>
  )
}
